import { ActionSheetContext, ActionSheetV2, type ActionSheetV2Props, Button } from '@alto/design-system';
import React, { useContext } from 'react';
import { Linking } from 'react-native';
import { CONTACT_US_ORIGIN, PROGYNY_PHONE } from '~shared/constants';
import { stripNonDigits } from '~shared/helpers/string';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { ContactUs } from '../../alto-assistant';

type Props = Pick<ActionSheetV2Props, 'title' | 'footnote' | 'children'> & { readonly origin: string };

export const ContactProgynyActionSheet = ({ title, footnote, origin, children }: Props) => {
  const { trackEvent } = useAnalytics();
  const { closeActionSheet } = useContext(ActionSheetContext);

  const handleOnPressMessageUs = () => {
    closeActionSheet();
  };

  const onPressCallProgyny = () => {
    trackEvent({
      event: EVENTS.CALL_US_CLICKED,
      params: {
        origin,
        phoneNumber: PROGYNY_PHONE,
        web: false,
      },
    });
    Linking.openURL(`tel://${stripNonDigits(PROGYNY_PHONE)}`);
  };

  return (
    <ActionSheetV2
      title={title}
      footnote={footnote}
      buttons={[
        <ContactUs
          type="button"
          key="Send a message"
          customLabel="Send a message"
          method="message"
          origin={CONTACT_US_ORIGIN.DosageChangeContactUsActionSheet}
          onPressCallback={handleOnPressMessageUs}
        />,
        <Button
          type="tertiary"
          key={`call ${PROGYNY_PHONE}`}
          onPress={onPressCallProgyny}
        >
          {`Call ${PROGYNY_PHONE}`}
        </Button>,
      ]}
    >
      {children}
    </ActionSheetV2>
  );
};
